import { GET_REVIEW_QUERIES_LOGS, GET_FEEDBACK_SUMMARY,GET_DESPOSITION_SUMMARY,GET_REVIEW_SUMMMARY, 
  GET_FEEDBACK_DETAILS_REVIEWED,GET_FEEDBACK_DETAILS_SUBMITTED,GET_DETAILS_KNOWLEDGE_GAP,GET_DETAILS_KNOWLEDGE_GAP_REVIEWED, 
  GET_DETAILS_REVIEWED_CONVERSATION, SET_APPLIED_FILTERS, 
  SET_FILTER_APPLYING} from '../../common/actionTypes.js';

const INITIAL_STATE = {
  feedbackSummary: [],
  reviewQueriesLogs: null, // Initialize reviewQueriesLogs state
  despositionSummary: [],// Initialize despositionSummary state
  reviewSummary: [],// Initialize reviewSummary state
  feedbackDetailsReviewed:[],
  feedbackDetailsSubmitted:[],
  getDetailsKnowledgeGap:[],
  getDetailsKnowledgeGapReviewed:[],
  getDetailsReviewedConversation:[],
  appliedFilters: null
};

const ConversationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_FEEDBACK_SUMMARY: {
      return { ...state, feedbackSummary: action.payload };
    }
    case GET_REVIEW_QUERIES_LOGS:
      return {
        ...state,
        reviewQueriesLogs: {
          data: action.payload,
        }
      };
    case GET_DESPOSITION_SUMMARY: { // Handle the new action
      return { ...state, despositionSummary: action.payload };
    }
    case GET_REVIEW_SUMMMARY: { // Handle the new action
      return { ...state, reviewSummary: action.payload };
    }
    case  GET_FEEDBACK_DETAILS_REVIEWED: { // Handle the new action
      return { ...state, feedbackDetailsReviewed: action.payload };
    }
    case  GET_FEEDBACK_DETAILS_SUBMITTED: { // Handle the new action
      return { ...state, feedbackDetailsSubmitted: action.payload };
    }
    case  GET_DETAILS_KNOWLEDGE_GAP: { // Handle the new action
      return { ...state, getDetailsKnowledgeGap: action.payload };
    }
    case  GET_DETAILS_KNOWLEDGE_GAP_REVIEWED: { // Handle the new action
      return { ...state, getDetailsKnowledgeGapReviewed: action.payload };
    }
    case  GET_DETAILS_REVIEWED_CONVERSATION: { // Handle the new action
      return { ...state, getDetailsReviewedConversation: action.payload };
    }
    case SET_APPLIED_FILTERS:
      return { ...state, appliedFilters: action.payload };
    case SET_FILTER_APPLYING:
      return {
        ...state,
        isFilterApplying: action.payload
      };
    
    default:
      return state;
  }
};

export default ConversationReducer;
